export default __webpack_public_path__ + "static/media/Winifred.615c1e9d.png";